/** Affiche la journée en format court (ex. « J22 »). */
export function formatJourneeShort(journee?: string | null): string {
  const raw = String(journee ?? '').trim();
  if (!raw) return '-';
  const withoutPrefix = raw.replace(/^journée\s*/i, '').trim();
  const num = withoutPrefix.match(/\d+/)?.[0];
  if (num) return `J${num}`;
  if (/^j\d+/i.test(raw)) return raw.toUpperCase();
  return raw;
}
